/* eslint-disable object-shorthand */

/* global Chart, CustomTooltips, getStyle, hexToRgba */
//import $ from 'jquery'

window.basePath = window.basePath || '../';


function getUrlParam( paramName ) {
	var reParam = new RegExp( '(?:[\?&]|&)' + paramName + '=([^&]+)', 'i' );
	var match = window.location.search.match( reParam );

	return ( match && match.length > 1 ) ? match[1] : null;
}

function stripTags(html)
{
   var tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}

// WYSIWYG
function unloadEditors()
{
	$('.sortable-by-btn [class*=ckeditor]:hidden').each(function()
	{
		var tagId = $(this).attr('id');
		CKEDITOR.instances[tagId].destroy();
	});
}

function loadEditors()
{
	$(".sortable-by-btn .ckeditor-title").each(function () {
		CKEDITOR.replace( $(this).attr("name"), { customConfig: '../ckeditor_configs/config_title.js' });
	});
	$(".sortable-by-btn .ckeditor-perex").each(function () {
		CKEDITOR.replace( $(this).attr("name"), { customConfig: '../ckeditor_configs/config_perex.js' });
	});
	$(".sortable-by-btn .ckeditor-full").each(function () {
		CKEDITOR.replace( $(this).attr("name"), { customConfig: '../ckeditor_configs/config_full.js' });
	});
}

// administration app
app = {
	f: function (func) {
		if (typeof func === 'function')
			return $.proxy(func, this);
		else
			return $.proxy(this[func], this);
	},

	init: function (data) {
		var ctx = $(document);

		if (data) {
			if (data.redirect) {
				window.location.href = data.redirect;
				return;
			}

			if (data.snippets) {
				ctx = $();

				for (var i in data.snippets) {
					var $targ = $('#' + i);
					$targ.html(data.snippets[i]);
					ctx = ctx.add($targ);
				}
			}
			else
				ctx = $(data);
		}
	},

	libraryInit: function () {
		var self = this;

		this.$files = $('.files');
		this.$current = null;

		$('<div class="files-info" />').insertBefore('.addAttachement');

		$(document)
			.on("click", '.addAttachement', $.proxy(app.openWin, app))
			.on('click', '.remAttachement', $.proxy(app.removeFromList, app));

		this.$files.each(function (i, e) {
			var $this = $(e),
				data = self.deserialize($this.val());

			if (data) {
				self.createList(data, $this);
			}
		});
	},

	// serialize photos for input
	serialize: function (ids, files) {
		var length = files.length,
			result = '{';

		if (!length)
			return '';

		for (var i = 0; i < length; i++) {
			var sep = i === 0 ? '' : ',';
			result += sep + '"' + ids[i] + '":"' + files[i] + '"';
		}

		return result + '}';
	},

	deserialize: function (data)
	{
		try {
			var jsonConfig = JSON.parse(data);
			return jsonConfig;
		} catch(e) {
			console.error('Cannot parse JSON config on element: ', this.$files, "JSON Data: " + data);
			console.error(e);
			return false;
		}
	},

	idsToString: function (ids) {
		var result = '',
			sep = '';

		for (var i = 0, len = ids.length; i < len; i++) {
			sep = i === 0 ? '' : '-';
			result = result + sep + ids[i];
			result = result.replace("ID", "");
		}

		return result;
	},

	// create list of attachements
	createList: function (jsonConfig, $element) {

		if (typeof parameters.fileTypes !== 'object')
			return;

		$element = this.$current || $element;

		var html = '',
			multi = $element.data('multi'),
			viewType = $element.data('type'),
			fileTypes = parameters.fileTypes;

		for (var id in jsonConfig)
		{
			switch (viewType)
			{
				case 'picture':
					figure = '<figure class="file figure p-2 mr-2 rounded" data-id="'+ id +'" data-url="' + jsonConfig[id].path + '" data-name="' + jsonConfig[id].name + '">' +
						'		<span class="figure-overlay-wrap active">' +
						'			<img class="img-fluid" src="'+ jsonConfig[id].path + '">' +
						'			<span class="figure-overlay">' +
						'				<a href="#" class="btn btn-pill btn-danger remAttachement" role="button"><i class="cui-trash"></i> Odstranit</a>' +
						'			</span>' +
						'		</span>' +
						'		<figcaption class="figure-caption">' + jsonConfig[id].name +' </figcaption>' +
						'	</figure>';

					break;
				default: 
					figure = '<figure class="file figure p-2 mr-2 rounded" data-id="'+ id +'" data-url="' + jsonConfig[id].path + '">' +
						'		<span class="figure-overlay-wrap active">' +
						'			<div class="file-thumb"><i class="cui-file" /></div>' +
						'			<span class="figure-overlay">' +
						'				<a href="#" class="btn btn-pill btn-danger remAttachement" role="button"><i class="cui-trash"></i> Odstranit</a>' +
						'			</span>' +
						'		</span>' +
						'		<figcaption class="figure-caption">' + jsonConfig[id].name +' </figcaption>' +
						'	</figure>';
			}

			html += figure;
		}

		html += '</div>';

		$html = $(html);
		$html.hide();

		this.cleanList($element);
		$element.val(JSON.stringify(jsonConfig));
		$element.siblings('.files-info').html($html);
		this.$current = null;
		$html.fadeIn(400);
		return;
	},

	// clean list of attachements
	cleanList: function ($element) {
		$element.val('');
		$element.siblings('.files-info').empty();
	},

	// remove attachement from list
	removeFromList: function (e) {
		var $this = $(e.currentTarget),
			$file = $this.closest('.file'),
			$files = $file.closest('.files-info').siblings('.files'),
			id = $file.data('id').toString(),
			data;

		data = JSON.parse($files.val());

		delete data[id];
		$files.val(JSON.stringify(data));
		$file.fadeOut(400, e => $file.remove());

		e.preventDefault();
	},

	// open new window with media gallery
	openWin: function (e) {
		e.preventDefault();

		var $this = $(e.currentTarget),
			href = $this.attr('href'),
			sep = href.indexOf('?') < 0 ? '?' : '&',
			multi = false,
			data = {};

		this.$current = $this.siblings('input.files');
		multi = this.$current.data('multi') || false;
		jsonConfig = this.deserialize(this.$current.val());
		href += sep + 'multi=' + multi;
		href = Object.keys(jsonConfig) ? href + '&ids=' + this.idsToString(Object.keys(jsonConfig)) : href;

		window.open(href, 'filebrowser', "width=1024,height=" + (screen.height * 0.75) + ",left=" + ((screen.width - 1024) / 2) + ",top=" + ((screen.height - (screen.height * 0.75)) / 2) + ",toolbar=no,status=no,resizable=yes,dependent=yes,scrollbars=yes");
	},

	// tiny callback for file browser
	openPopup: function (field_name, url, type, win) {
		var cmsURL = window.libraryUrl;

		// add the type as an query parameter
		// (PHP session ID is now included if there is one at all)
		var separator = cmsURL.indexOf('?') < 0 ? '?' : '&';
		cmsURL += separator + 'filter[type]=' + (type == 'image' ? 1 : 10);
		this.input = field_name;

		tinymce.activeEditor.windowManager.open({
			file: cmsURL,
			title: '',
			width: 1024,  // Your dimensions may differ - toy around with them!
			height: screen.height * 0.75,
			resizable: "yes",
			close_previous: "no"
		});
	},

	// close popup media gallery created in TinyMCE
	closePopUp: function (url) {
		if (url) {
			$('#' + this.input).val(url);
		}

		tinymce.activeEditor.windowManager.close();
	},

	closePopUpCkEditor: function (url) {
		var funcNum = getUrlParam( 'CKEditorFuncNum' );
		window.opener.CKEDITOR.tools.callFunction( funcNum, url );
		window.close();
	},

	setSpinner: function (event) {
		// spinner CSS
		$("#ajax-spinner").show().css({
			position: "absolute",
			left: event ? event.pageX + 20 : "50%",
			top: event ? event.pageY + 40 : "50%"
		});
	},

	sortableThumbsInit: function()
	{
		$(".files-info").sortable(
		{
			placeholder: "file figure p-2 mr-2 rounded ui-sortable-placeholder",
			update: function (e, ui)
			{
				// prepare value
				var jsonConfig = {};

				var data = "{";
				// get childrens
				$(this).find(".file").each(function (index)
				{
					// var id = $(this).attr('data-id');
					var id = $(this).data('id').toString();
					var ids = '"' + id + '"';
					var url = $(this).attr('data-url');
					var name = $(this).attr('data-name');
					jsonConfig[ids] = { "name": name, "path": url };
				});
				var data = "}";

				// update value
				var value = JSON.stringify(jsonConfig);
				value = value.replace(/\\"/g, "");
				$(this).siblings('input.files').val(value);
			}
		});
	}
};


// Media gallery
gallery = {
	libraryInit: function()
	{
		// ID in popup URL
		var ids = this.findInUrl('ids');

		this.type = typeof(parent.tinymce) !== 'undefined' ? 'popup' : 'window';
		this.multi = this.findInUrl('multi');
		this.files = [];
		this.names = [];
		this.jsonConfig = {};
		this.ids = ids ? ids.split('-') : [];

		// Files declared in HTML
		if(typeof files != 'undefined')
		{
			this.jsonConfig = app.deserialize(files);
		}

		this.selectItems();

		$(document)
			.on('click', '.addAttachementFile', $.proxy(gallery.clickItem, gallery))
			.on('click', '.done', $.proxy(gallery.clickOk, gallery))
			.on('click', '.cancel', $.proxy(gallery.clickCancel, gallery));
	},

	// select item(s)
	clickItem: function(e)
	{
		var $this = $(e.currentTarget),
			path = $this.data('url'),
			id = "ID" + $this.data('id'),
			name = $this.data('name'),
			$parentRow = $this.parents('tr');

		if(this.multi === 'true')
		{
			if($this.hasClass('selected'))
			{
				delete this.jsonConfig[id];

				if ($parentRow.length > 0) {
					$parentRow.removeClass('selected');
				}

				$this.removeClass('selected');
			} else{

				$this.addClass('selected');

				this.jsonConfig[id] = { "name": name, "path":  path};

				if ($parentRow.length > 0) {
					$parentRow.addClass('selected');
				}
			}
		} else {
			this.jsonConfig = {};
			this.jsonConfig[id] = { "name": name, "path":  path};
			this.clickOk();
		}

		e.preventDefault();
	},

	selectItems: function(){

		for (var id in this.jsonConfig)
		{
			var id2 = id.replace("ID", "");
			var $item = $('[data-id="' + id2 + '"]');
			$item.addClass('selected');

			var $parentRow = $item.parents('tr');
			if ($parentRow.length > 0) {
				$parentRow.addClass('selected');
			}
		}
	},

	// close popup or window and call for setting selected files
	clickOk: function(e){
		if(e)
			e.preventDefault();

		if(getUrlParam( 'CKEditorFuncNum' )) {
			parent.app.closePopUpCkEditor(Object.values(this.jsonConfig)[0].path);
		} else if(this.type === 'popup') {
			parent.app.closePopUp(Object.values(this.jsonConfig)[0].path);
		} else {
			window.opener.app.createList(this.jsonConfig, null);
			window.close();
		}
	},

	// close popup or window without save
	clickCancel: function(e){
		e.preventDefault();

		if(getUrlParam( 'CKEditorFuncNum' )){
			parent.app.closePopUpCkEditor();
		}else if(this.type === 'popup'){
			parent.app.closePopUp();
		}
		else{
			window.close();
		}
	},

	findInUrl: function(attr){
		var get = location.href.split('?')[1],
			params = get && get.split('&');

		if(params){
			for(var i = 0, length = params.length; i < length; i++){
				var parts = params[i].split('=');
				if(parts[0] === attr){
					return parts[1];
				}
			}
		}

		return false;
	}
};

$(document).ready(function()
{
	// App init
	app.init();

	// CKEditor & library
	//app.libraryInit();
	gallery.libraryInit();

	// Library - sortable
	//app.sortableThumbsInit();

	$(window).focus(function () {
		app.sortableThumbsInit();
	});

	// $(window).load(function () {
	// 	app.sortableThumbsInit();
	// });
});


// Misc 

$(document).on("change", ".upload-button", e => 
{
	let file = e.currentTarget.files[0];

	if (file)
		previewImage(file);

	function previewImage(file)
	{
		let thumb = $(e.currentTarget).parents(".file-upload-preview")[0];
		let overlay = $(e.currentTarget).parents(".figure-overlay-wrap");
		let reader = new FileReader();
		let parentFigure = $(e.currentTarget).parents(".figure");
		let cloneFigure = parentFigure.clone().fadeOut();

		if (thumb) {
			reader.onload = function()
			{
				cloneFigure.insertBefore(parentFigure);
				cloneFigure.fadeIn(500);
				thumb.style.backgroundImage = 'url(' + reader.result + ')';
			}

			$(overlay).addClass('active');
		}

		reader.readAsDataURL(file);
	}
});

$(document).on('click', '.js-thumb-delete', e =>
{
	e.preventDefault();

	let overlay = $(e.currentTarget).parents(".figure-overlay-wrap");
	let thumb = overlay.find(".file-upload-preview");
	let parentFigure = $(e.currentTarget).parents(".figure");

	let file = overlay.find("input[type=file]");
	file.value = '';

	let wrapper = $(e.currentTarget).parents(".images-upload-wrapper");
	parentFigure.fadeOut(500, f =>
	{
		thumb[0].style = '';
		overlay.removeClass("active");
		parentFigure.remove();
	});
});

window.modalReset = function(el)
{
	$parentModal = $(el).parents('.modal');
	$content = $parentModal.find('.modal-content');

	$content.html('');
	$parentModal.modal('hide');
}

// Save tabs state
$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
	activeTab = e.target;
	$selectedTabInput = $("#selected-tab");
	var ix = $(activeTab).parent('li').index();

	if ($selectedTabInput) {
		$selectedTabInput.attr("value", ix);
	}  
})

// Link attachment

function pageLinkSelect(page, field) {
	$('input[name="' + field + '"]').val('page:' + page);
}

$(document).on('click', '.pageLinkOpen', function (e) {
	link = $(this).attr('data-link-open');
	input = $(this).parents('.form-group').find('.form-control');
	inputName = input.attr('name');
	inputValue = input.val();
	pageLinkOpen(link, inputName, inputValue);
	e.preventDefault();
});

function pageLinkOpen(link, inputName, inputValue){
	var regex = /page:([0-9]+)/g;
	var result = regex.exec(inputValue);

	link = link + '&field=' + inputName.toString();
	if (result && result[0]) {
		var idParent = result[1];
		link = link + '&idParent=' + idParent.toString();

	}

	rozmery="1200,800";

	var mujso=screen.availWidth-60;
	var mujvo=screen.availHeight-80;

	tmp_rozmery=rozmery.split(",");
	var zobraz_sirka= Math.min(tmp_rozmery[0], mujso);
	var zobraz_vyska = Math.min(tmp_rozmery[1], mujvo);

	var zobraz_left=(mujso/2)-(zobraz_sirka/2);
	var zobraz_top=(mujvo/2)-(zobraz_vyska/2);

	pagePageLibraryWindowHandler = window.open(link, "pagePageLibraryWindow","width="+zobraz_sirka+",height="+zobraz_vyska+",top="+zobraz_top+",left="+zobraz_left+",scrollbars=1");
	pagePageLibraryWindowHandler.focus();
}

function selectPage(page) {
	if (this.field) {
		window.opener.pageLinkSelect(page, this.field);
		window.close();
	} else {
		var dialog = window.opener.CKEDITOR.dialog.getCurrent();
		dialog.setValueOf('info','protocol','');
		window.opener.CKEDITOR.tools.callFunction(getUrlParam('CKEditorFuncNum'), 'page:' + page);
		window.close();
	}
}

// Boxes sorting & collapsing
$(document).on('click', '.js-collapse-boxes', e =>
{
	var $btn = $(e.currentTarget);
	var buttonTextBackup = $btn.html();
	var buttonText = $btn.data('toggle-text') || buttonTextBackup;

	$btn.html(buttonText);
	$btn.data('toggle-text', buttonTextBackup);

	$('.collapse').collapse('toggle');

	e.preventDefault();
});

$('.collapse').on('show.bs.collapse', function (e)
{
	var id = e.currentTarget.getAttribute('id');
	var $sourceToggler = $('[data-target="#' + id + '"]');
	var $sourceButton = $sourceToggler.find('button i');

	$sourceButton.removeClass('fa-plus-square').addClass('fa-minus-square');
});

$('.collapse').on('hide.bs.collapse', function (e)
{
	var id = e.currentTarget.getAttribute('id');
	var $sourceToggler = $('[data-target="#' + id + '"]');
	var $sourceButton = $sourceToggler.find('button i');

	$sourceButton.removeClass('fa-minus-square').addClass('fa-plus-square');
});

$(document).on('click', '.js-move-down-btn', e =>
{
	e.preventDefault();

	var item = $(e.currentTarget).closest('.card');
	var next = item.next();

	next.css('z-index', 999).css('position', 'relative').animate({ top: '-' + item.height() }, 250);
	item.css('z-index', 1000).css('position', 'relative').animate({ top: next.height() }, 300, function () {
		next.css('z-index', '').css('top', '').css('position', '');
		item.css('z-index', '').css('top', '').css('position', '');

		unloadEditors();
		item.insertAfter(next);
		loadEditors();
	});
});

$(document).on('click', '.js-move-up-btn', e =>
{
	e.preventDefault();

	var item = $(e.currentTarget).closest('.card');
	var prev = item.prev();

	prev.css('z-index', 999).css('position','relative').animate({ top: item.height() }, 250);
	item.css('z-index', 1000).css('position', 'relative').animate({ top: '-' + prev.height() }, 300, function () {
		prev.css('z-index', '').css('top', '').css('position', '');
		item.css('z-index', '').css('top', '').css('position', '');

		unloadEditors();
		item.insertBefore(prev);
		loadEditors();
	});
});

// Table filter

var $resetBtn = $('<span class="input-group-append js-input-reset"><button class="btn btn-danger" type="button"><i class="fa fa-remove"></i></button></span>');

$(document).on('click', '.js-input-reset', function(e)
{
	var $input = $(this).prev('input');

	$input.val('').focus();
	$input.trigger('keyup');
	$(this).remove();

	e.preventDefault();
});

$(document).on('click', '.table-filter input[type="radio"]', function(e)
{
	$('.js-filter-table').trigger('keyup');
});

$(document).on('keyup', e =>
{
	if ($(e.target).hasClass('js-filter-table'))
	{
		var $input = $(e.target);
		var $tables = $('.' + $input.data('target-table-class'));
		var filterText = $input[0].value.toUpperCase();
		var $submitBtn = $input.closest('form').find('button[type=submit]');
		var parentTabId, $parentTabLink;

		// Show reset button
		if (filterText.length > 0) {
			$resetBtn.insertAfter($input);
		} else {
			$resetBtn.remove();
		}

		// Filter connected tables
		$tables.map((i, table) =>
		{
			var $trs = $(table).find('tr');
			var shown_count = 0;

			parentTabId = $(table).closest('.tab-pane').attr('id');
			$parentTabLink = $('a[href="#' + parentTabId + '"]');

			// Filter by first TD in TRs
			$trs.map((i, tr)  =>
			{
				var $td, txtValue;

				$td = $(tr).find('td').first().find('strong');
				if (!$td.length)
					return false;

				txtValue = $td[0].textContent || $td[0].innerText;

				// Hide show row and disable submit if needed
				if (txtValue.toUpperCase().indexOf(filterText) > -1)
				{
					if ($(tr).find('input:checked').length)
						$submitBtn.attr('disabled', false);

					shown_count++;
					$(tr).show(200);
					$(tr).removeClass('hidden');
				} else {
					if ($(tr).find('input:checked').length)
						$submitBtn.attr('disabled', true);

					$(tr).hide(500);
					$(tr).addClass('hidden');
				}
			});

			// Numbers of templates found
			if ($parentTabLink.length)
			{
				var $num = $parentTabLink.find('.num');
				if ($num.length) {
					$num.html(shown_count);
					if (shown_count < 1) {
						$num.addClass('disabled');
					} else {
						$num.removeClass('disabled');
					}
				}
			}

			// Show error if needed
			var $error = $(table).find('.filter-error');
			$error.map(() => {
				if (shown_count < 1) {
					$error.addClass('shown');
				} else {
					$error.removeClass('shown');
				}
			});
		});

	}
});

// Plugins
window.initPlugins = function()
{
	// Sortable
	$(".sortable").sortable({
		axis: 'y',
		update: function (event, ui) {
			var data = $(this).sortable('serialize');
		}
	});

	$(".sortable-by-btn").sortable({
		axis: 'y',
		handle: ".js-sortable-btn",
		update: function (event, ui) {
			var data = $(this).sortable('serialize');
		},
		start: function(event,ui) {
			unloadEditors();
		},
		stop: function(event,ui) {
			loadEditors();
		}
	});

	// Datepicker
	if ($().datetimepicker) {
		$('.datepicker').datetimepicker({
			format: 'L',
			locale: 'cs'
		});
	
		// Timepicker
		$('.timepicker').datetimepicker({
			format: 'LT',
			locale: 'cs'
		});
	}

	// WYSIWYG
	$(".ckeditor-title").each(function () {
		CKEDITOR.replace( $(this).attr("name"), { customConfig: '../ckeditor_configs/config_title.js' });
	});
	$(".ckeditor-perex").each(function () {
		CKEDITOR.replace( $(this).attr("name"), { customConfig: '../ckeditor_configs/config_perex.js' });
	});
	$(".ckeditor-full").each(function () {
		CKEDITOR.replace( $(this).attr("name"), { customConfig: '../ckeditor_configs/config_full.js' });
	});

	// Sortable boxes — naming
	$('.js-card-auto-title').each((i, card) =>
	{
		var $cardBarTitle = $(card).find('.js-bind-card-title');
		var $cardBody = $(card).find('.card-body');
		var $firstInput = $cardBody.find('input[type=text], textarea').first();
		var boxTitle;

		if ($firstInput.length)
		{
			boxTitle = stripTags($firstInput[0].value);
			$cardBarTitle.html(boxTitle);

			$firstInput.on('keydown', (e) =>
			{
				boxTitle = stripTags(e.target.value);
				$cardBarTitle.html(boxTitle);
			});
		}
	});

	// App modules
	app.libraryInit();
	app.sortableThumbsInit();

};

initPlugins();


// Nette
$(function () {
	$.nette.init();
});

(function ($, undefined) {

	$.nette.ext('spinner', {
		init: function (x) {
			this.spinner = this.createSpinner();
			this.spinner.appendTo('body');
		},
		before: function() {
			// WYSIWYG AJAX update
			for (instance in CKEDITOR.instances) {
				CKEDITOR.instances[instance].updateElement();
			}
		},
		start: function (jqXHR, settings) {
			this.spinner.css({
				right: '40px',
				bottom: '40px'
			});
			this.spinner.addClass('active');
		},
		complete: function () {
			this.spinner.removeClass('active');
			initPlugins();
		}
	}, {
		createSpinner: function () {
			var spinner = $('<div>', {
				id: 'ajax-spinner'
			});
			var icon = $('<i>', {
				class: 'fa fa-spinner'
			});

			spinner.append(icon);

			return spinner;
		},
		spinner: null,
		speed: undefined
	});

	$.nette.ext('galleryInit', {
		complete: function () {
			gallery.selectItems();
		}
	});

})(jQuery);

// Old modal
$(document).on("click", ".ajax-modal", function (e) {
	e.preventDefault();
	var href = $(this).attr('href');
	var target = $(this).attr('data-ajax-target');
	if (!href || !target) return false;
	target = '.' + target;
	$.ajax({
		url: href,
		type: 'post',
		//data: {userid: userid},
		success: function (response) {
			$(target).find('.modal-content').html(response);
			$(target).modal('show');
		}
	});
});